import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe, inject } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'safeHtml',
  pure: true,
})
export class SafeHtmlPipe implements PipeTransform {
  #domSanitizer = inject(DomSanitizer);

  transform(value: string) {
    return this.#domSanitizer.bypassSecurityTrustHtml(value);
  }
}
